//----------------------------------
// get substring before find string
//----------------------------------
export default function getSubstringBeforeFindString(whole_string, find_string) {
  //-------------------
  // check valid parms
  //-------------------
  if (typeof whole_string !== 'string' || typeof find_string !== 'string') {
    return ''
  }
  //-----------------------------------
  // find substring before find string
  //-----------------------------------
  const idx = whole_string.indexOf(find_string)
  //---------------------------------
  // not found - return whole string
  //--------------------------------
  if (idx === -1) return whole_string
  //-----------------------
  // else return substring
  //-----------------------
  return whole_string.substring(0, idx)
}
